export const API_REGISTER_DEVICE = "/auth/device"
export const API_SAVE_BOOKING = "/bookings"
export const API_UPDATE_BOOKING = "/bookings/%s"
export const API_GET_QUESTIONNAIRE = "/questionnaires/%s"
export const API_CHECKIN_BOOKING = "/bookings/%s/checkin"
export const API_CHECKIN_SPACE = "/spaces/%s/checkin"
export const API_AUTHORIZATION_TOKEN = "/auth/authorization-token"
export const API_DEVICE_CONFIG = "/devices/%s/config"
export const API_DEVICE_BOOKING_LIST = "/devices/%s/booking-list"
export const API_DEVICE_MAINTENANCE = "/devices/%s/maintenance"